<template>
  <page>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> Filters
                </div>
              </v-expansion-panel-header>
                <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.usrRefId" :label="filtersLabel.usrRefId" :error-messages="errors.collect('usrRefId')" data-vv-name="usrRefId" :data-vv-as="filtersLabel.usrRefId" v-validate="'entry|max:60'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.firstName" :label="filtersLabel.firstName" :error-messages="errors.collect('firstName')" data-vv-name="firstName" :data-vv-as="filtersLabel.firstName" v-validate="'name|max:60'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.lastName" :label="filtersLabel.lastName" :error-messages="errors.collect('lastName')" data-vv-name="lastName" :data-vv-as="filtersLabel.lastName" v-validate="'name|max:60'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.email" type="email" :label="filtersLabel.email" :error-messages="errors.collect('email')" data-vv-name="email" :data-vv-as="filtersLabel.email" v-validate="'email'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.mobileNo" v-int-mask="{intScale: 8}" type="tel" :label="filtersLabel.mobileNo" :error-messages="errors.collect('mobileNo')" data-vv-name="mobileNo" :data-vv-as="filtersLabel.mobileNo" v-validate="'numeric'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.officeNo" v-int-mask="{intScale: 8}" type="tel" :label="filtersLabel.officeNo" :error-messages="errors.collect('officeNo')" data-vv-name="officeNo" :data-vv-as="filtersLabel.officeNo" v-validate="'numeric'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-autocomplete :items="intermediaryList" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-int-mask="{intScale: 5}" v-model="filters.id" :label="filtersLabel.id" type="tel" :error-messages="errors.collect('id')" data-vv-name="id" :data-vv-as="filtersLabel.id" v-validate="'numeric'"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <message :messages="messages"></message>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <div>
                  <v-btn color="primary" @click.prevent="doExportList" v-if="checkAccess([permissionKeys.perm_091020])">
                    Export To Excel
                    <v-icon right>mdi-file-export</v-icon>
                  </v-btn>
                  <v-btn class="mx-2" color="primary" @click="doNew" v-if="checkAccess([permissionKeys.perm_091005])">
                    New User
                    <v-icon right>mdi-account-plus</v-icon>
                  </v-btn>
                </div>
              </v-layout>
            </v-card-title>
            <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :loading="loading"
            :server-items-length="totalItems"
            :no-data-text="noDataText"
            v-bind:options.sync="pagination"
            >
            <template v-slot:item="row">
              <tr>
                <td>
                  <v-avatar :size="35" :class="getAvatarColor(row.item.userId)">
                    <span class="white--text">
                      {{ formatInitials(row.item.firstName, row.item.lastName) }}
                    </span>
                  </v-avatar>
                </td>
                <td>{{ row.item.usrRefId }}</td>
                <td class="text-right">{{ row.item.firstName }}</td>
                <td class="text-right">{{ row.item.lastName }}</td>
                <td class="text-right">{{ row.item.email }}</td>
                <td class="text-right">{{ row.item.intermediary }}</td>
                <td class="text-right">{{ formatBoolean(row.item.acctDisabled) }}</td>
                <td class="text-right">{{ formatDate(row.item.createdDate) }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" :query="checkAccess([permissionKeys.perm_091015])" :review="checkAccess([permissionKeys.perm_091010])" @query="doQuery" @review="doReview"></table-action>
                </td>
              </tr>
            </template>
          </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { ADMINUSER_INTERMEDIARY } from '@/store/types'
import { permissionKeys } from '@/mixins/global/permissionKey'
import { initials } from '@/utils/name'
import { getAvatarColor } from '@/utils/global'

export default {
  data() {
    return {
      headers: [
        { text: '', value: 'avatar', width: '15px', align: 'center', sortable: false },
        { text: 'Ref ID', align: 'left', value: 'usrRefId' },
        { text: 'First Name', align: 'right', value: 'firstName' },
        { text: 'Last Name', align: 'right', value: 'lastName' },
        { text: 'Email', align: 'right', value: 'email' },
        { text: 'Intermediary', align: 'right', value: 'intermediary' },
        { text: 'Acct Disabled', align: 'right', value: 'acctDisabled', sortable: false },
        { text: 'Created Date', align: 'right', value: 'createdDate', sortable: false },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      filters: {
        usrRefId: null,
        id: null,
        firstName: null,
        lastName: null,
        email: null,
        mobileNo: null,
        officeNo: null,
        intermediary: null
      },
      filtersLabel: {
        usrRefId: 'Reference Id',
        id: 'User Id',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        mobileNo: 'Mobile No.',
        officeNo: 'Office No.',
        intermediary: 'Intermediary'
      },
      tabs: null,
      permissionKeys: permissionKeys,
      usrItems: [],
      isClearFilter: true,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    intermediaryList() {
      return this.$store.state.adminUser.intermediaryList
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.adminUser.menu.usersList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              this.usrItems = []
              data.map((user) => {
                const convertUser = {
                  id: user.userId,
                  usrRefId: user.usrRefId,
                  firstName: user.firstName,
                  lastName: user.lastName,
                  email: user.email,
                  mobileNo: user.mobileNo,
                  officeNo: user.officeNo,
                  acctDisabled: user.acctDisabled,
                  intermediary: user.intermediaryName,
                  createdDate: user.createdDate,
                  userId: user.userId
                }
                this.items.push(convertUser)
                if (!this.isClearFilter) {
                  this.usrItems.push(user.userId)
                }
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$store.commit(ADMINUSER_INTERMEDIARY, result.data.intermediaryList)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doExportList() {
      // OK-496
      this.loadingRoleDetail = true
      const apiURI = this.$store.state.adminUser.menu.exportExcel
      if (apiURI) {
        try {
          const expand = {
            usrItems: this.usrItems.join()
          }
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.loadingRoleDetail = false
            return data
          } else {
            this.$toast.error('Unexpected server response')
          }
        } catch (err) {
          throw err
        }
      } else {
        this.$toast.error('Missing api URI (fetch role detail)')
      }
      this.loadingRoleDetail = false
    },
    doQuery(data) {
      if (data && data.item && data.item.id) {
        this.$router.push({ name: 'userQuery', params: { id: data.item.id } })
      }
    },
    doReview(data) {
      if (data && data.item && data.item.id) {
        this.$router.push({ name: 'userReview', params: { id: data.item.id } })
      }
    },
    doNew() {
      this.$router.push({ name: 'userReview', params: { id: 'new' } })
    },
    doClearFilters() {
      this.isClearFilter = true
      this.filters.usrRefId = null
      this.filters.id = null
      this.filters.firstName = null
      this.filters.lastName = null
      this.filters.email = null
      this.filters.mobileNo = null
      this.filters.officeNo = null
      this.filters.intermediary = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.isClearFilter = false
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    async doExportUserRoles() {
      const apiURI = this.$store.state.adminUser.menu.exportUsrRoles
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.get(apiURI)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    formatInitials(fname, lname) {
      return initials(fname, lname)
    },
    getAvatarColor(userId) {
      return getAvatarColor(userId)
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ],
  components: {
    // Members
  }
}
</script>

<style lang="scss">
</style>
